import { Controller } from "@hotwired/stimulus"

// Submits the surrounding form when a control changes. Replaces the inline
// onchange handler that used to rewrite window.location by regex.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
